(function (napco, $) {
	napco.functionName = function () {
		var $container = $('');
		if (!$container.length) {
			return;
		}
	};
}(window.napco = window.napco || {}, jQuery));
